
/* eslint-disable */
    import {useStore} from "@/store";
    // , computed, ComputedRef, watch, reactive
    import {defineComponent, reactive, ComputedRef, computed, toRefs} from "vue";
    import imgSrcAccident from '@/assets/toc/accidentImg.png';
    import imgSrcFire from '@/assets/toc/fireImg.png';
    import imgSrcWater from '@/assets/toc/waterImg.png';
    import iconOk from '@/assets/toc/ok.png';
    import iconWarn from '@/assets/toc/warn.png';
    import  reportMsgUt from "@/util/reportMsg";

     interface State {
         imgSrc: string;
         content: string;
         icon: string;
         tit: string;
         nopadding: boolean;
         smallpadding: boolean;
         contentAccidentNo: string;
         contentAccidentYes: string;
         contentFireNo: string;
         contentFireYes: string;
         contentWaterNo: string;
         contentWaterYes: string;
         contentShowType: boolean;
         reportMsg: object;

     }
export default defineComponent({
    name: 'checkDescrip',
    props: {
        itemCode: {
            type: String,
            default: ''
        }
    },
    setup(props) {
        //
        let state: State = reactive({
            imgSrc: '',
            content: '',
            icon: '',
            tit: '',
            nopadding: false,
            smallpadding: false,
            contentShowType: false,
            contentAccidentNo: '经检测如车辆结构件（如纵梁、ABCD柱、防火墙等24处部位）未存在钣金修复、严重变形、切割、锈蚀锈透任一缺陷，或加强件（如底大边、翼子板内骨架等21处部位）中未存在切割缺陷时，认定为非重大事故车，具体标准详见268V检测认证承诺书附件《268V检测认定标准》。',
            contentAccidentYes: '经检测如车辆结构件（如纵梁、ABCD柱、防火墙等24处部位）存在钣金修复、严重变形、切割、锈蚀锈透任一缺陷，或加强件（如底大边、翼子板内骨架等21处部位）中有存在切割缺陷时，认定为重大事故车，具体标准详见268V检测认证承诺书附件《268V检测认定标准》。',
            contentFireNo: '经检测如车辆（如减震器座、发动机舱、行李箱舱等19项部位）未存在烟熏、碳化、受热变形任一情况，或存在烟熏、碳化、受热变形任一情况，但单个部件缺陷面积小于0.3平方米，即认定为非火烧车，具体标准详见268V检测认证承诺书附件《268V检测认定标准》。',
            contentFireYes: '经检测如车辆（如减震器座、发动机舱、行李箱舱等19项部位）中有存在烟熏、碳化、受热变形任一情况，且单个部件缺陷面积大于等于0.3平方米，即认定为火烧车，具体标准详见268V检测认证承诺书附件《268V检测认定标准》。',
            contentWaterNo: '经检测如车辆（如发动机舱、驾驶室、地胶（毯）等43项部位）中未存在明显的水印、泥沙、锈蚀、霉斑、泡水修复等迹象，或有存在迹象但未达到三处，认定为非泡水车，具体标准详见268V检测认证承诺书附件《268V检测认定标准》。',
            contentWaterYes: '经检测如车辆（如发动机舱、驾驶室、地胶（毯）等43项部位）中存在明显的水印、泥沙、锈蚀、霉斑、泡水修复等迹象，且达到三处或三处以上，认定为泡水车，具体标准详见268V检测认证承诺书附件《268V检测认定标准》。',
            reportMsg: {},
        })
        state.reportMsg = reportMsgUt;
        const {itemCode} = toRefs(props)
        // console.dir(props);
        let store = useStore()
        let isFire: ComputedRef<{}> = computed<{}>(() => (store.state.dataInfo as any).isFire);
        let isWater: ComputedRef<{}> = computed<{}>(() => (store.state.dataInfo as any).isWater);
        let isAccident: ComputedRef<{}> = computed<{}>(() => (store.state.dataInfo as any).isAccident);
        // console.log(`isFire：${isFire.value}, isWater:${isWater.value}, isAccident:${isAccident.value}`);
        let desCont: ComputedRef<{}> = computed<{}>(() => {
            let obj={
                src: '',
                isWrong: false,
                cont: '',
                icon: '',
                tit: '',
                nopadding: false,
                smallpadding: false,
            };
            // console.log(itemCode.value);
            switch (itemCode.value) {
                case 'Accident':
                    obj.src = imgSrcAccident;
                    obj.nopadding = true
                    if (isAccident.value) {
                        obj.cont = state.contentAccidentYes;
                        obj.isWrong = true;
                        obj.icon = iconWarn;
                        obj.tit = '认定此车为重大事故';
                    } else {
                        obj.cont = state.contentAccidentNo;
                        obj.isWrong = false;
                        obj.icon = iconOk;
                        obj.tit = '排除此车重大事故';
                    }
                    break;
                case 'Fire':
                    obj.src = imgSrcFire;
                    if (isFire.value) {
                        obj.cont = state.contentFireYes;
                        obj.isWrong = true;
                        obj.icon = iconWarn;
                        obj.tit = '认定此车为火烧车';
                    } else {
                        obj.cont = state.contentFireNo;
                        obj.isWrong = false;
                        obj.icon = iconOk;
                        obj.tit = '排除此车火烧车';
                    }
                    break;
                case 'SoakWater':
                    obj.src = imgSrcWater;
                    obj.smallpadding = true
                    if (isWater.value) {
                        obj.cont = state.contentWaterYes;
                        obj.isWrong = true;
                        obj.icon = iconWarn;
                        obj.tit = '认定此车为泡水车';
                    } else {
                        obj.cont = state.contentWaterNo;
                        obj.isWrong = false;
                        obj.icon = iconOk;
                        obj.tit = '排除此车泡水车';
                    }
                    break;
            }
            return obj;
        });
        // console.log(desCont);
       (state as any).imgSrc = (desCont.value as any).src;
       (state as any).content = (desCont.value as any).cont;
       (state as any).tit = (desCont.value as any).tit;
       (state as any).icon = (desCont.value as any).icon;
       (state as any).nopadding = (desCont.value as any).nopadding;
       (state as any).smallpadding = (desCont.value as any).smallpadding;
       function changeShowType() {
           state.contentShowType = !state.contentShowType;
       }
        return {
            state,
            changeShowType
        }
    },
    
})
